import { List, ListItem, ListItemButton } from "@mui/material";
import { M_Button } from "../../../M_Components";
import { useTranslation } from "react-i18next";

export const EntityList = ({ entities, handleEdit, handleDelete, handleItemClick, selectedEntityId, isAdmin, isConfiguration, canEdit = true, canDelete = true }) => {
    const [t, i18n] = useTranslation();
    return (
        <>
            <List>
                {
                    entities?.map(entity => {
                        var secondaryButtons;
                        if (isAdmin && isConfiguration) {
                            secondaryButtons = (
                                <div className="entity-list-buttons">
                                    {canEdit && (
                                        <M_Button
                                            tooltip={t("Edit")}
                                            label={t("Edit")}
                                            icon={<i className='pi pi-pencil iconTable'></i>}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleEdit(entity.EntityId);
                                            }}
                                        />
                                    )}
                                    {canDelete && (
                                        <M_Button
                                            tooltip={t("Delete")}
                                            icon={<i className='pi pi-trash iconTable'></i>}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDelete(entity.EntityId);
                                            }}
                                        />
                                    )}
                                </div>
                            )
                        } else {

                            secondaryButtons = <div></div>

                        }

                        return (
                            <ListItem
                                disablePadding
                                key={entity.EntityId}
                                secondaryAction={secondaryButtons}
                            >
                                <ListItemButton
                                    onClick={() => handleItemClick(entity.EntityId)}
                                    selected={entity.EntityId === selectedEntityId}
                                >
                                    <div className="text">{entity.Code}</div>
                                </ListItemButton>
                            </ListItem>
                        )
                    })
                }
            </List>
        </>
    );
};
